(ns ui.components.alert-list.view
  (:require
   [re-frame.core :as rf]
   [ui.components.alert-list.event :as event]
   [ui.components.alert-list.sub :as sub]
   [ui.components.alert.view :as alert]))

(defn view
  [list-id]
  (let [alerts @(rf/subscribe [::sub/alerts list-id])]
    (when (seq alerts)
      [:ul
       {:class "flex flex-col gap-3"}
       (->> alerts
            (map (fn [{:keys [id variant message-content] :as alert}]
                   ^{:key (str "alert-" list-id "-" id)}
                   [:li
                    {:class "flex flex-col"}
                    (case (or variant :info)
                      :danger [alert/danger
                               {:on-close #(rf/dispatch [::event/remove-alert list-id id])}
                               message-content]
                      :warning [alert/danger
                                {:on-close #(rf/dispatch [::event/remove-alert list-id id])}
                                message-content]
                      :info [alert/danger
                             {:on-close #(rf/dispatch [::event/remove-alert list-id id])}
                             message-content]
                      (do (js/console.log "Unknown alert list variant : " variant)
                          [alert/danger
                           {:on-close #(rf/dispatch [::event/remove-alert list-id id])}
                           message-content]))])))])))
